import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IEditDefaultPricicingPocRequest } from "@shared/lib/types/brief";
import { BriefService } from "../services/brief.service";
import { setBriefByIdQueryData } from "./useGetBriefById";

export function useEditDefaultPricingPoc() {
  const {
    mutate: editDefaultPricingPoc,
    isLoading: isEditingDefaultPricingPoc,
    isSuccess: isEditedDefaultPricingPoc,
  } = useMutation({
    mutationFn: (data: IEditDefaultPricicingPocRequest) =>
      BriefService.editDefaultPricicingPoc(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: { skipInvalidation: true },
    onSuccess: (queryClient, response, variables) => {
      setBriefByIdQueryData(queryClient, variables.briefId, response);
      ToastService.success("Default pricing POC updated successfully");
    },
  });

  return {
    editDefaultPricingPoc,
    isEditingDefaultPricingPoc,
    isEditedDefaultPricingPoc,
  };
}
